import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subject } from 'rxjs';
import { map, shareReplay, switchMap, takeUntil } from 'rxjs/operators';
import { AuthService } from '../service/auth.service';
import { Router } from '@angular/router';
import { FireAssessmentService } from '../../services/fire-assessment.service'; // CRUD API service class
import { AngularFirestore } from '@angular/fire/firestore';
import { AuthGuard } from '../guard/auth.guard';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit, OnDestroy {
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );
  SignOut() {
    this.authService.SignOut();
  }

  title = 'Sustainible Assessment Engine';
  itemKeys = [];
  data = [];

  isAdmin: boolean;
  isSuperAdmin: boolean;
  isEntrepreneur: boolean;

  private unsubscribe = new Subject();

  constructor(
    private db: AngularFirestore,
    public authService: AuthService,
    private breakpointObserver: BreakpointObserver,
    public router: Router,
    public ngZone: NgZone,
    public fireAssessment: FireAssessmentService,
    private guard: AuthGuard,
    private afAuth: AngularFireAuth
  ) {}

  ngOnInit() {
    this.afAuth.authState
      .pipe(
        switchMap((user: firebase.User) =>
          this.db
            .collection('super-admin-users', (ref) =>
              ref.where('email', '==', user?.email || null)
            )
            .get()
        )
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((value) => {
        this.isSuperAdmin = !!value.docs.find(
          (doc: any) => !!doc.data()?.email
        );
        this.authService.isSuperAdmin = this.isSuperAdmin;
      });
  }

  //userData = this.authService.userData;

  reload() {
    this.router.navigate(['view-assessments']);
  }

  // K-Andre function to get itemKey and data for view.
  getItemKeys() {
    const assessmentList = this.fireAssessment.readAssessmentsList();
    assessmentList
      .snapshotChanges()
      .pipe(
        map((actions) =>
          actions.map((a) => ({
            key: a.payload.doc.id,
            ...a.payload.doc.data(),
          }))
        )
      )
      .subscribe((data) => {
        this.itemKeys = data.map((item) => item.key);
        this.data = data;
        return this.itemKeys;
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
